import * as type from './constant';

const initialState = {
  dataExecutor: [],

  updatedExecutor: null,
  addedExecutor: null,
  deletedExecutor: null,

  loading: false,
  loadingManipulation: false,
  error: null,
  errorManipulation: null,

  dataExecutorSelf: null,
};
export default (state = initialState, action) => {

  switch (action.type) {

    case type.GET:
      return {
        ...state,
        updatedExecutor: null,
        addedExecutor: null,
        deletedExecutor: null,
        loading: true,
        loadingManipulation: false,
        error: null,
        errorManipulation: null,
      };

    case type.GET_SUCCESS:
      return {
        ...state,
        dataExecutor: [...action.payload],
        loading: false,
      };

    case type.GET_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case type.ADD:
      return {
        ...state,
        addedExecutor: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.ADD_SUCCESS:
      return {
        ...state,
        addedExecutor: action.payload,
        loadingManipulation: false,
      };

    case type.UPDATE:
      return {
        ...state,
        updatedExecutor: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.UPDATE_SUCCESS:
      return {
        ...state,
        updatedExecutor: action.payload,
        loadingManipulation: false,
      };

    case type.DELETE:
      return {
        ...state,
        deletedExecutor: null,
        loadingManipulation: true,
        errorManipulation: null,
      };

    case type.DELETE_SUCCESS:
      return {
        ...state,
        deletedExecutor: action.payload,
        loadingManipulation: false,
      };

    case type.MANIPULATION_ERROR:
      return {
        ...state,
        loadingManipulation: false,
        errorManipulation: action.error,
      };

    case type.GET_SELF:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case type.GET_SELF_SUCCESS:
      return {
        ...state,
        dataExecutorSelf: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};
